import React from "react";
import Button from "../elements/Button/Button";
const ActionManagement = () =>{
    return(
        <>
            <div className="p-4">
                <div className="flex">
                    <div className="w-1/2 items-center">
                    <p className="mb-0 text-xl font-[500]">Manage Actions</p>
                    <p className="font-[400] text-sm text-[#1D1D1D] mb-0">Will be run automatically on receiving or sending emails</p>
                    </div>
                    <div className="w-1/2 items-center justify-center">
                    <Button className="py-2 px-4 text-[#059669] bg-white border-2 border-[#059669] float-right my-auto flex">Add <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="15" height="15" className="my-auto ml-1" viewBox="0 0 24 24">
<path fill="#059669" d="M 11 2 L 11 11 L 2 11 L 2 13 L 11 13 L 11 22 L 13 22 L 13 13 L 22 13 L 22 11 L 13 11 L 13 2 Z"></path>
</svg></Button>
                    </div>
                </div>
            </div>
        </>
    );

}
export default ActionManagement;